// import CustomParams = Gtag.CustomParams;
import { Injectable } from '@angular/core';

declare global {
  export interface Window {
    gtag: any;
  }
}

interface Params extends Partial<Record<string, string | number>> {
  source?: string;
}

interface ClickParams extends Params {
  source?: string;
  page?: string;
}

enum SendEvents {
  zoom = "zoom",
  expenses = "expenses_page_displayed",
  fleet_overview = "fleet_overview_page_displayed",
  trip_manager = "trip_manager_page_displayed",
  schedule_trip = "schedule_trip_page_displayed",
  calendar = "calendar_page_displayed",
  calendar_beta = "calendar_beta_page_displayed"
}

@Injectable()
export class AnalyticsService {
  private event = (eventName: string, eventParameters?: Params) => {
    if (process.env.NODE_ENV === 'production' && window.gtag) {
      window.gtag('event', eventName, eventParameters);
    }
  };

  private log = (eventName: string, eventParameters?: Params) => {
    if (process.env.NODE_ENV !== 'production') {
      console.log(`%c Analytics: ${eventName}`, 'color: white; background: red', eventParameters);
    }
  };

  sendEvent = (eventName: keyof typeof SendEvents , eventParameters?: Params) => {
    this.log(eventName, eventParameters);
    this.event(eventName, eventParameters);
  };

  sendViewEvent = (eventName: string, eventParameters?: Params) => {
    this.log(`Event view "${eventName}"`, eventParameters);
    this.event(`view_${eventName}`, eventParameters);
  };

  clickButton = (buttonName: string, eventParameters?: ClickParams) => {
    this.log(`Click button "${buttonName}"`, eventParameters);
    this.event('click_button', { button_name: buttonName, ...eventParameters });
  };

  clickTab = (tabName: string | number, eventParameters?: Params) => {
    this.log(`Click tab "${tabName}"`, eventParameters);
    this.event('click_tab', { tab_name: tabName, ...eventParameters });
  };

  clickInput = (inputName: string, eventParameters?: ClickParams) => {
    this.log(`Click input "${inputName}"`, eventParameters);
    this.event('click_input', { input_name: inputName, ...eventParameters });
  };

  clickSwitch = (switchName: string, eventParameters?: ClickParams) => {
    this.log(`Click switch "${switchName}"`, eventParameters);
    this.event('click_switch', { switch_name: switchName, ...eventParameters });
  };

  clickCheckBox = (checkBoxName: string, eventParameters?: ClickParams) => {
    this.log(`Click checkbox "${checkBoxName}"`, eventParameters);
    this.event('click_checkbox', { checkbox_name: checkBoxName, ...eventParameters });
  };

  submitForm = (formName: string, eventParameters?: Params) => {
    this.log(`Submit form "${formName}"`, eventParameters);
    this.event('form_submit', { form_name: formName, ...eventParameters });
  };
}
